import { Component } from 'react'
import { ProductItemsModal as CoreProductItemsModal } from 'core/components'
import { Product } from 'stylewhere/api'
import { OperationConfig } from 'stylewhere/shared'
import { getProductBarcodeValue } from 'custom/cucinelli/shared/utils'

export class ProductItemsModal extends CoreProductItemsModal {
  getProductCode = (product: Product) => {
    const operation = (this.props as any).operation as OperationConfig | undefined
    return getProductBarcodeValue(product, operation) || product.code
  }
}
